import { put, call, take, fork } from 'redux-saga/effects'
import { courseTimeSeriesListService } from '../../api/course-time-series'
import { courseTimeSeriesListSuccess } from '../../reducers/course-time-series/action'
import { COURSE_TIME_SERIES_LIST } from '../../reducers/course-time-series/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* courseTimeSeriesListFlow(payload) {
  try {
    const { query } = payload
    const response = yield call(courseTimeSeriesListService, query)
    if (
      response.data.results.length == 0 &&
      query.FilterText == '' &&
      query.Filters == undefined
    ) {
      response.data.results = null
    }
    yield put(courseTimeSeriesListSuccess(response.data))
    yield put(operationSuccess())
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* courseTimeSeriesListWatcher() {
  while (true) {
    const action = yield take(COURSE_TIME_SERIES_LIST)
    const { payload } = action

    yield fork(generalSaga, courseTimeSeriesListFlow, payload)
  }
}
